import React, { Component, Fragment } from 'react';
import {
    LoadingComponent,
    PageListComponent,
    HeaderListComponent,
    FormActionComponent,
} from "../../../common/component/Index";
import DEFINE, { ORDER, PATHS } from "../../../../../constants/Define";
import { get, isEmpty, isEqual } from 'lodash';
import * as Func from '../../../../../helpers/functions';
import Order from '../../../../../models/Order';
import Wrapper from './../../../common/component/Wrapper';

import Reservation from '../../../../../models/Reservation';

import OrderInfo from './OrderInfo';
import InvoiceInfo from './InvoiceInfo';
import SmsHistories from './SmsHistories';
import FlightDetail from './FlightDetail';
import GolfDetail from './GolfDetail';

import TourInfo from './TourInfo';
import VinWonderInfo from './VinWonderInfo';
import VoucherInfo from './VoucherInfo';
import HotelInfo from './HotelInfo';
import SurchargeInfo from './SurchargeInfo'
import SurchargeItemDetail from './SurchargeInfo/SurchargeItemDetail';
import ChangeRateCode from './ChangeRateCode';
import { omit } from 'lodash';

import './OrderDetail.less';
import Modal from '../../../common/component/Modal';
import { Icon } from 'antd';
import OrderProfiles from './OrderProfiles';
import FixchargeInfo from './FixchargeInfo';
import HomestayInfo from './HomestayInfo';
import PointSpendLog from './PointSpendLog';
import PointSaveLog from './PointSaveLog';
import FnbInfo from './FnBInfo';

let permissionActions = [];
let permissionTourActions = [];
let permissionFlightTracking = [];
const defaultState = {

};
export default class OrderDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            order: this.props.orderState.detail.order,
            orderGolf: this.props.orderState.orderGolf,
            validation: {},
            openModalDetail: false,
            idItemSelect: undefined,
            variantIdSelect: undefined,
            orderItemType: undefined,
            fetchDetail: false,
            openModalRateCode: false,
            rateCodeId: null,
            orderId: null,
            productType: null,
            itemVariantId: null
        };
    }

    componentDidMount() {
        permissionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.ORDER);
        permissionTourActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.TOUR);
        permissionFlightTracking = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.FLIGHT_TRACKING);
        this.initDetail();
    }

    initDetail() {
        const { match } = this.props;
        if (Object.keys(match.params).length > 0 && match.params.id) {
            const id = match.params.id;
            this.props.getOrderDetail(id);
            this.props.getAllEmailTemplates();
            // this.props.getItemSurchargeOrder({ orderId: id });
            this.setState({ orderId: id });
        }
        this.props.getListAirlineDomestic();
        this.props.getListAirportDeparture();
        this.props.getListAirportArrival();
        // this.props.getListFlightTrackingOrder(match.params.id);
    }

    componentWillUnmount() {
        this.props.setOrderDetail(new Order())
    }

    componentWillReceiveProps(nextProps) {
        if (get(nextProps, 'orderState.detail.order.id') && !isEqual(get(nextProps, 'orderState.detail.order'), get(this.props, 'orderState.detail.order'))) {
            this.getDetailItems(nextProps.orderState.detail.order);

            // get vinwonder customers submarine
            const orderDetail = get(nextProps, 'orderState.detail.order');
            if ((orderDetail.itemTypes || []).includes(ORDER.TYPES.VINWONDER_NEW.id)) {
                this.props.getVinwonderCustomers(orderDetail?.id);
                this.props.getSmsHistories(orderDetail?.id);
            }
            this.props.getPointHistories(orderDetail?.id);
            if(orderDetail?.id && orderDetail?.id !== 'undefined' && orderDetail?.itemTypes?.includes(ORDER.ITEMTYPES.GOLF.id) && orderDetail?.channel === 12) {
                this.props.getOrderDetailGolf(orderDetail?.id);
            }
            
        }
        if (get(nextProps, 'orderState.detail.orderItem') && get(nextProps, 'orderState.detail.orderItem') !== get(this.props, 'orderState.detail.orderItem')) {
            this.getOrderItemDetails(nextProps.orderState.detail.orderItem);
        }
    }

    render() {
        const { t, orderState, emailTemplateState, match, airportState } = this.props;
        const { isFetching, isFetchingItems, isFetchingGetDetailVoucher, isFetchingFlight, isFetchingHotel, detail, isFetchingUpdateOrderStatus, isPushingFixedCharge, isFetchingSmsHistories, isResendSms, isFetchingUpdateProfile, isFetchingPointHistories } = orderState;
        const { flight, reservations, orderItem, voucherFilters, voucherItems, surcharges, customers } = detail;
        const { order, validation, idItemSelect, openModalDetail, variantIdSelect, orderItemType, openModalRateCode, rateCodeId, orderId, productType, itemVariantId } = this.state;
        const allowSurcharge = order.status === 2 || order.status === 4;
        const orderInfoGolf =  orderState.orderGolf        
        return (
            <LoadingComponent spinning={isFetching || isFetchingUpdateOrderStatus}>
                <PageListComponent className="page-detail-page">
                    <HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'pages'}
                        onClickBack={this.onClickBack}
                        titleHeader={Func.capitalizeFirstLetter((`${t('action.detail')} ${t('item.order.title')}`.toLowerCase()))}
                    />
                    <FormActionComponent
                        isSubmit={false}
                        disabledFooter={true}
                    >
                        <OrderInfo order={order} loading={isFetching || emailTemplateState.isFetching || isFetchingUpdateOrderStatus}
                            loadingEmail={orderState.isFetchingEmail}
                            validation={validation}
                            permisions={permissionActions}
                            emailTemplates={emailTemplateState.allEmailTemplates}
                            onUpdateOrder={this.onUpdateOrderInfo}
                            onUpdateOrderAccountant={this.onUpdateOrderAccountantInfo}
                            onSendTemplateEmail={this.onSendTemplateEmail}
                            orderItem={orderItem}
                            reservations={reservations}
                            orderGolf={orderInfoGolf || []}
                        />
                        {!!order.invoice &&
                            <InvoiceInfo invoice={order.invoice} loading={isFetching || isFetchingUpdateOrderStatus}
                                validation={validation}
                                permisions={permissionActions}
                                onUpdateInvoice={this.onUpdateOrderInvoice} />
                        }
                        {!isEmpty(order.orderProfiles) &&
                            <OrderProfiles
                                validation={validation}
                                validationProfile={this.validateProfile}
                                permisions={permissionActions}
                                orderProfiles={order.orderProfiles}
                                loading={isFetching || isFetchingUpdateProfile}
                                onSave={this.props.onUpdateProfile}
                                resetValidate={this.resetValidate}
                            />
                        }
                        {order.itemTypes.includes(ORDER.TYPES.VINWONDER_NEW.id) &&
                            <SmsHistories onResendSms={this.props.resendSms}
                                smsHistories={orderState.detail?.smsHistories || []}
                                loading={isFetchingSmsHistories || isResendSms} />
                        }

                        <PointSpendLog
                            spendHistories={orderState.detail?.pointHistories?.data?.filter(data => data.type === 0) || []}
                            loading={isFetchingPointHistories}
                            permisions={permissionActions}
                            order={order}
                        />
                        <PointSaveLog
                            saveHistories={orderState.detail?.pointHistories?.data?.filter(data => data.type === 1) || []}
                            loading={isFetchingPointHistories}
                        />
                        <FixchargeInfo onResend={this.props.resendFixCharge}
                            smsHistories={orderState.detail?.smsHistories || []}
                            loading={isFetchingSmsHistories || isResendSms} />
                        {/* //! Voucher Type Order */}
                        {order.itemTypes.includes(ORDER.TYPES.VOUCHER.id) &&
                            <VoucherInfo
                                permisions={permissionActions}
                                onUpdateItem={this.onUpdateItem}
                                allowSurcharge={allowSurcharge}
                                vouchers={orderItem.vouchers}
                                voucherItems={voucherItems}
                                permissionFlightTracking={permissionFlightTracking}
                                order={order}
                                orderId={order.id}
                                orderState={orderState}
                                filters={voucherFilters}
                                loading={isFetching || isFetchingUpdateOrderStatus}
                                loadingList={isFetchingGetDetailVoucher}
                                removeSurcharge={this.removeSurcharge}
                                onItemExpanded={this.onItemExpanded}
                                createModalSurcharge={this.createModalSurcharge}
                                openDetailSurcharge={this.openDetailSurcharge}
                                showConfirmLockItem={this.showConfirmLockItem}
                                onGetDetailVoucher={this.onGetDetailVoucher}
                                onChangeRateCode={this.onChangeRateCode}
                                airlineDomestic={airportState.airlineDomestic}
                                airportDeparture={airportState.airportDeparture}
                                airportArrival={airportState.airportArrival}
                            // flightTrackingOrder={orderState.detail.flightTrackingOrder}
                            />
                        }
                        {order.itemTypes.includes(ORDER.TYPES.TOUR.id) &&
                            <TourInfo
                                tours={orderItem.tours}
                                loading={isFetchingItems}
                                onUpdateItem={this.onUpdateItem}
                                permisions={permissionActions}
                                permissionFlightTracking={permissionFlightTracking}
                                permissionTourActions={permissionTourActions}
                                createModalSurcharge={this.createModalSurcharge}
                                openDetailSurcharge={this.openDetailSurcharge}
                                onChangeRateCode={this.onChangeRateCode}
                                removeSurcharge={this.removeSurcharge}
                                onItemExpanded={this.onItemExpanded}
                                allowSurcharge={allowSurcharge}
                                showConfirmLockItem={this.showConfirmLockItem}
                                orderId={order.id}
                                orderCode={order.orderCode}
                                orderState={orderState}
                                getRateCodeDetail={this.props.getRateCodeDetail}
                                rateCodeDetail={this.props.rateCodeState.rateCodeDetail || {}}
                                airlineDomestic={airportState.airlineDomestic}
                                airportDeparture={airportState.airportDeparture}
                                airportArrival={airportState.airportArrival}
                            // flightTrackingOrder={orderState.detail.flightTrackingOrder}
                            />
                        }
                        {order.itemTypes.includes(ORDER.TYPES.VINWONDER_NEW.id) &&
                            <TourInfo
                                tours={orderItem.vinWonderTour}
                                loading={isFetchingItems}
                                onUpdateItem={this.onUpdateItem}
                                permisions={permissionActions}
                                permissionTourActions={permissionTourActions}
                                createModalSurcharge={this.createModalSurcharge}
                                openDetailSurcharge={this.openDetailSurcharge}
                                onChangeRateCode={this.onChangeRateCode}
                                removeSurcharge={this.removeSurcharge}
                                onItemExpanded={this.onItemExpanded}
                                allowSurcharge={allowSurcharge}
                                showConfirmLockItem={this.showConfirmLockItem}
                                orderId={order.id}
                                orderCode={order.orderCode}
                                orderState={orderState}
                                getRateCodeDetail={this.props.getRateCodeDetail}
                                rateCodeDetail={this.props.rateCodeState.rateCodeDetail || {}}
                                isVinwonderNew={true}
                                customers={customers}
                            />
                        }
                        {order.itemTypes.includes(ORDER.TYPES.VINWONDER.id) &&
                            <VinWonderInfo
                                onUpdateItem={this.onUpdateItem}
                                allowSurcharge={allowSurcharge}
                                removeSurcharge={this.removeSurcharge}
                                onItemExpanded={this.onItemExpanded}
                                createModalSurcharge={this.createModalSurcharge}
                                openDetailSurcharge={this.openDetailSurcharge}
                                vinWonders={orderItem.vinWonders}
                                permisions={permissionActions}
                                loading={isFetchingItems} />
                        }
                        {(order.itemTypes.includes(ORDER.TYPES.HOTEL.id) || order.itemTypes.includes(ORDER.TYPES.LINKCROSSSELL.id)) &&
                            <HotelInfo
                                onUpdateItem={this.onUpdateItem}
                                order={order}
                                allowSurcharge={allowSurcharge}
                                removeSurcharge={this.removeSurcharge}
                                onItemExpanded={this.onItemExpanded}
                                createModalSurcharge={this.createModalSurcharge}
                                openDetailSurcharge={this.openDetailSurcharge}
                                openModalSurcharge={this.openModalSurcharge}
                                reservations={reservations}
                                hotels={orderItem.hotels}
                                permisions={permissionActions}
                                loading={isFetchingHotel || isFetchingItems || isFetching || isFetchingUpdateOrderStatus} />
                        }
                        {(order.itemTypes.includes(ORDER.TYPES.HOMESTAY.id)) &&
                            <HomestayInfo
                                type="homestays"
                                onUpdateItem={this.onUpdateItem}
                                order={order}
                                allowSurcharge={allowSurcharge}
                                removeSurcharge={this.removeSurcharge}
                                onItemExpanded={this.onItemExpanded}
                                createModalSurcharge={this.createModalSurcharge}
                                openDetailSurcharge={this.openDetailSurcharge}
                                openModalSurcharge={this.openModalSurcharge}
                                reservations={reservations}
                                homestays={orderItem.homestays}
                                permisions={permissionActions}
                                loading={isFetchingHotel || isFetchingItems || isFetching || isFetchingUpdateOrderStatus} />
                        }
                        {order.itemTypes.includes(ORDER.TYPES.FLIGHT.id) &&
                            <FlightDetail
                                order={order}
                                flight={flight}
                                itemTypes={order?.itemTypes || []}
                                permisions={permissionActions}
                                onUpdateItem={this.onUpdateItem}
                                onUpdateFlight={this.props.onUpdateFlight}
                                onPushFixedCharge={this.props.onPushFixedCharge}
                                isPushingFixedCharge={isPushingFixedCharge}
                                loading={isFetchingFlight || isFetchingItems || isFetching || isFetchingUpdateOrderStatus}
                                reservations={reservations} />
                        }
                        {order.itemTypes.includes(ORDER.ITEMTYPES.GOLF.id) &&
                            <GolfDetail
                                teeTimes={orderInfoGolf?.teeTimes || []}
                                order={order}
                                orderInfoGolf={orderInfoGolf}
                            />
                        }
                        {order.itemTypes.includes(ORDER.TYPES.FNB.id) &&
                            <FnbInfo
                                fnbs={orderItem.fnbs}
                                order={order}
                                t={t}
                                loading={isFetchingItems}
                            />
                        }
                    </FormActionComponent>
                </PageListComponent>
                <SurchargeItemDetail
                    visible={openModalDetail}
                    idItemSelect={idItemSelect}
                    variantIdSelect={variantIdSelect}
                    orderItemType={orderItemType}
                    orderId={order.id}
                    onSubmit={this.closeModalDetail}
                    onCancel={this.closeModalDetail} />
                <ChangeRateCode
                    visible={openModalRateCode}
                    rateCodeId={rateCodeId}
                    onSubmit={this.closeModalChangeRateCode}
                    onCancel={this.closeModalChangeRateCode}
                    orderId={orderId}
                    productType={productType}
                    itemVariantId={itemVariantId}
                />
            </LoadingComponent>
        );
    }

    showConfirmLockItem = (orderItem, title) => {
        const { confirm } = Modal;
        const { t } = this.props;
        orderItem.orderId = this.state.order.id
        confirm({
            title: t(`item.order.${orderItem.isLocked ? 'confirmUnLockOrderItem' : 'confirmLockOrderItem'}`),
            icon: <Icon type={`${orderItem.isLocked ? 'unlock' : 'lock'}`} />,
            content: title,
            okText: t(`action.${orderItem.isLocked ? 'unlock' : 'lock'}`),
            cancelText: t(`action.cancel`),
            onOk: (closeConfirm) => {
                this.props.lockOrderItem(orderItem);
                closeConfirm();
            },
        });
    }

    onItemExpanded = (expanded, item, listType = '') => {
        const filters = { orderId: this.state.order.id, itemVariantId: item.itemVariantId, ...omit(item.detail, ['items']) };
        this.props.getItemSurchargeOrder(filters, listType);
    }

    getDetailItems(order) {
        this.setState({ order })
        if (this.state.fetchDetail) {
            return
        }
        this.props.getOrderItems(order.id);
        this.setState({ fetchDetail: true })
    }

    onClickBack = () => {
        this.props.history.push(PATHS.ORDER.LIST.path);
    }

    createModalSurcharge = (variantId, orderItemType) => {
        this.setState({ orderItemType: orderItemType, variantIdSelect: variantId, openModalDetail: true });
    }

    onChangeRateCode = (rateCodeId, itemVariantId, productType) => {
        this.setState({ openModalRateCode: true, rateCodeId: rateCodeId, itemVariantId: itemVariantId, productType: productType });
    }

    closeModalChangeRateCode = () => {
        this.setState({ openModalRateCode: false, rateCodeId: null });
    }

    openDetailSurcharge = (variantId, id, orderItemType) => {
        this.setState({ variantIdSelect: variantId, idItemSelect: id, orderItemType: orderItemType, openModalDetail: true });
    }

    closeModalDetail = () => {
        this.setState({ variantIdSelect: undefined, idItemSelect: undefined, openModalDetail: false });
    }

    removeSurcharge = (surcharge) => {
        this.props.deleteSurchargeDetail(surcharge)
    }

    onGetDetailVoucher = (params) => {
        const { filters } = params;
        const { order } = this.state;
        const productVariantId = filters.groupId;
        const orderId = order.id;
        this.props.getDetailVoucherOrder({ orderId, productVariantId, ...filters });
    }

    onUpdateItem = (tourItem, callBack) => {
        const { order } = this.state;
        tourItem.orderId = order.id;
        this.props.updateOrderItem(tourItem, callBack);
    }

    onUpdateOrderInfo = (order) => {
        if (this.validate(order)) {
            this.props.onUpdateOrder(order);
        }
    }

    onUpdateOrderAccountantInfo = (order) => {
        this.props.onUpdateOrderAccountant(order);
    }

    onUpdateOrderInvoice = (invoice) => {
        this.props.updateOrderInvoice(invoice);
    }

    onSendTemplateEmail = (emailTemplate) => {
        const { order } = this.state;
        const { t } = this.props;
        const { confirm } = Modal;
        confirm({
            title: Func.formatValidation(t(`item.order.confirmSendMailTemplate`), t(`item.emailTemplate.title`)),
            content: emailTemplate.title,
            okText: t(`action.send`),
            cancelText: t(`action.cancel`),
            onOk: (closeConfirm) => {
                this.props.sendEmailTemplate(order, emailTemplate);
                closeConfirm();
            },
        });
    }
    resetValidate = () => {
        this.setState({ validation: {} })
    }
    validateProfile = (profile) => {
        const { t } = this.props;
        let validate = {
            required: {
                firstName: Func.formatValidation(t('validation.statusCode.code.1'), t('item.order.orderProfiles.firstName')),
                lastName: Func.formatValidation(t('validation.statusCode.code.1'), t('item.order.orderProfiles.lastName')),
                phoneNumber: Func.formatValidation(t('validation.statusCode.code.1'), t('item.order.orderProfiles.phoneNumber')),
                email: Func.formatValidation(t('validation.statusCode.code.1'), t('item.order.orderProfiles.email')),
                nationality: Func.formatValidation(t('validation.statusCode.1'), t('item.order.orderProfiles.nationality'))
            },
            isPhone: { phoneNumber: t('validation.isPhone') },
        }
        let valueValidate = {};
        const result = Func.multipleValidate(profile, validate, valueValidate);
        this.setState({ validation: result });
        return Object.keys(result).length < 1;
    }
    validate(order) {
        const { t } = this.props;
        let validate = {
            required: {
                firstname: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.user.firstname`)),
                lastname: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.user.lastname`)),
                phoneNumber: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.order.phoneNumber`)),
                email: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.order.email`)),
                // transactionId: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.order.transactionId`)),
                // paymentType: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.order.paymentType`)),
                // saleChannel: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.order.saleChannel`))
            },
            isPhone: { phoneNumber: t('validation.isPhone') },
            isEmail: { email: t('validation.email') },
        };
        if (order.paymentType && order.paymentType !== 'onepay') {
            // validate.required.transactionId = Func.formatValidation(t('validation.statusCode.code.1'), t(`item.order.transactionId`));
            validate.required.paymentType = Func.formatValidation(t('validation.statusCode.code.1'), t(`item.order.paymentType`));
            validate.required.saleChannel = Func.formatValidation(t('validation.statusCode.code.1'), t(`item.order.saleChannel`));
        }
        let valueValidate = {};
        const result = Func.multipleValidate(order, validate, valueValidate);
        this.setState({ validation: result });
        return Object.keys(result).length < 1;
    }

    getOrderItemDetails = (orderItem) => {
        const { order } = this.state;
        if (order.itemTypes.includes(ORDER.TYPES.FLIGHT.id) && orderItem.flight) {
            this.props.getOrderFlightItem(orderItem.flight.productVariantId);
        }
        if (order.itemTypes.includes(ORDER.TYPES.HOTEL.id)) {
            this.props.getOrderHotelBooking(orderItem.hotels.map(h => h.productVariantId));
        }
        if (order.itemTypes.includes(ORDER.TYPES.HOMESTAY.id) && orderItem?.homestays?.length) {
            this.props.getOrderHomestayBooking(orderItem?.homestays.map(h => h.productVariantId));
            // this.props.getOrderHotelBooking(orderItem.homestays.map(h => h.productVariantId));

        }
        if (order.itemTypes.includes(ORDER.TYPES.LINKCROSSSELL.id)) {
            this.props.getOrderCrossSellBooking(orderItem.linkCrossSales.map(h => h.productVariantId));
        }
    }

}
